import { isEmpty } from "lodash";

export const refineDomainName = (name, pattern = /---/g, char = "/") => {
  if (isEmpty(name)) return null;

  return name.replace(pattern, char);
};
